// extracted by mini-css-extract-plugin
module.exports =  {"source4":"Source4-PnlU__source4","metadata":"Source4-JVN1__metadata","link-adress":"Source4-Qc8S__link-adress","not-found":"Source4-nWMD__not-found"};